import { render, staticRenderFns } from "./TaskInfoView.vue?vue&type=template&id=39cf2f54&scoped=true&"
import script from "./TaskInfoView.vue?vue&type=script&lang=js&"
export * from "./TaskInfoView.vue?vue&type=script&lang=js&"
import style0 from "./TaskInfoView.vue?vue&type=style&index=0&id=39cf2f54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39cf2f54",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\project\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39cf2f54')) {
      api.createRecord('39cf2f54', component.options)
    } else {
      api.reload('39cf2f54', component.options)
    }
    module.hot.accept("./TaskInfoView.vue?vue&type=template&id=39cf2f54&scoped=true&", function () {
      api.rerender('39cf2f54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/InfoView/TaskInfoView.vue"
export default component.exports